import { render, staticRenderFns } from "./orderQuoteInfo.vue?vue&type=template&id=297b0731&scoped=true&"
import script from "./orderQuoteInfo.vue?vue&type=script&lang=js&"
export * from "./orderQuoteInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderQuoteInfo.vue?vue&type=style&index=0&id=297b0731&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b0731",
  null
  
)

export default component.exports